/** The date guard's badge on a social draft card (Randall, 11 Sep 2026 date audit).
 *  UNDATED = a live draft with no planned date; off-plan = a date that is not a slot in its
 *  campaign's calendar. Warnings only — neither blocks approval. Opaque hex: the Hub is a
 *  light theme, and translucent dark-theme values render pale-on-pale. */
export const DATE_FLAG_BADGE = {
  undated: { label: 'UNDATED', bg: '#FDE8E8', fg: '#8B1A1A' },
  off_plan: { label: 'off-plan', bg: '#FFF1DB', fg: '#7A4100' },
};
